<template>
  <div style="background-color: rgb(29,19,37)">
    <Ethereum :callback="initialize" />
    <Header :isHome="isHome" :buttonMsg="buttonMsg"/>
    <TermsMain id="termsMain" />
    <Footer id="footer" />
  </div>
</template>
<script>
import Ethereum from '/src/components/common/Ethereum.vue';
import Footer from '../home/components/Footer.vue';
import Header from '/src/pages/layout/Header.vue';
import TermsMain from './components/TermsMain.vue';

import { computed, ref, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter} from 'vue-router';

export default {
  components: {
    Ethereum,
    Header,
    TermsMain,
    Footer
  },

  setup() {
    const store = useStore();
    const router = useRouter();

    const isLoggedIn = computed(() => {
      return store.state.ethers.address;
    });

    const initialize = async () => {};

    const isHome = computed(() => {
      return router.currentRoute.value.path === '/';
    });

    const buttonMsg = computed(() => {
      return "MINT";
    });

    return {
      store,
      isHome,
      buttonMsg,
      isLoggedIn,
      initialize
    };
  }
};
</script>
